
<template>
    <div class="center">
      <vs-dialog v-model="active" @close="getBorrar">
        <template #header>
          <h4 class="not-margin">
            Inscribir grupo
          </h4>
        </template>

        <div>
            <vs-row class="mt-4">
                <!-- <vs-col sm="12" lg="6">
                    <form autocomplete="off">
                        <label for="cicloEscolar" class="labelInput">
                            Ciclo Escolar
                        </label>
                        <vs-select filter class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar" :disabled="!ciclosEscolares.length" autocomplete="off">
                            <template v-if="ciclosEscolares.length" autocomplete="off">
                                <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                            <template v-else>
                                <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                </vs-option>
                            </template>
                        </vs-select>
                    </form>
                </vs-col> -->
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="institucion" class="labelInput">
                            Nivel académico
                        </label>
                        <vs-select :loading="loadingNivel" class="pt-0" placeholder="Seleccionar nivel" :key="nivelId" v-model="nivel" v-if="niveles.length" :disabled="!niveles.length">
                            <template #message-danger v-if="errorFields.includes('nivel')">
                                Requerido
                            </template>
                            <vs-option v-for="option in niveles" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="institucion" class="labelInput">
                            Programa
                        </label>
                        <vs-select :loading="loadingPrograma" class=" pt-0" placeholder="Seleccionar programa" :key="programaId" v-model="programa" :disabled="!programas.length">
                            <template #message-danger v-if="errorFields.includes('programa')">
                                Requerido
                            </template>
                            <vs-option v-for="option in programas" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="institucion" class="labelInput">
                            Periodos
                        </label>
                        <vs-select :loading="loadingPeriodo" class="pt-0" placeholder="Seleccionar Periodos" :key="periodoId" v-model="periodo" :disabled="!periodos.length">
                            <template #message-danger v-if="errorFields.includes('periodo')">
                                Requerido
                            </template>
                            <vs-option v-for="option in periodos" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col>
            </vs-row>
        </div>

        <template #footer>
          <div class="footer-dialog">
              <vs-row>
                  <vs-col lg="6">
                    <vs-button
                        danger
                        flat
                        @click="getBorrar()"
                        style="width: 50%"
                    >
                        Cancelar
                    </vs-button>
                  </vs-col>
                  <vs-col lg="6">
                    <vs-button
                        success
                        @click="getInscribirMasivo()"
                        style="width: 50%"
                        class="ml-auto"
                    >
                        Aceptar
                    </vs-button>
                  </vs-col>
              </vs-row>
          </div>
        </template>
      </vs-dialog>
    </div>
</template>

<script>
import servicios from '../../../../api/requests/servicios'
import catalogos from '../../../../api/requests/catalogos'
export default {
    props:[
        'value',
        'row',
        'institucion',
        'ciclosEscolares',
        'cicloEscolar',
        'grupo'
    ],
    data(){
        return{
            active: false,
            email: '',
            password: '',
            remember: false,
            // cicloEscolar: '',
            cicloId: (new Date()).getTime(),
            nivel: '',
            niveles: [],
            nivelId: (new Date()).getTime(),
            errorNivel: false,
            programa: '',
            programas: [],
            programaId: (new Date()).getTime(),
            errorPrograma: false,
            periodo: '',
            periodos: [],
            periodoId: (new Date()).getTime(),
            errorPrograma: false,
            errorFields: [],
            loadingPeriodo: false,
            loadingNivel: false,
            loadingPrograma: false,
        }
    },
    methods: {
        getBorrar(){
            this.nivel = ''
            this.programa = ''
            this.periodo = ''
            this.active = false
        },
        sanityForm () {
            this.errorFields = []
            if (!this.nivel) {
                this.errorFields.push('nivel')
            }
            if (!this.programa) {
                this.errorFields.push('programa')
            }
            if (!this.periodo) {
                this.errorFields.push('periodo')
            }
            if (!this.errorFields.length){
                return true
            } else {
                return null
            }
        },
        async getInscribirMasivo(){
            if(this.sanityForm()){
                try {
                    const loading = this.$vs.loading()
                    const formData = new FormData();
                    formData.append('institucion_id', this.institucion)
                    formData.append('grupo_id', this.grupo)
                    formData.append('ciclo_escolar_id', this.cicloEscolar)
                    formData.append('nivel_academico_id', this.nivel)
                    formData.append('programa_id', this.programa)
                    formData.append('atributo_id', this.periodo)
                    const response = await catalogos.getInscribirMasivo(formData)
                    loading.close()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: 'bottom-right',
                        title: 'Inscripción éxitosa'
                    })
                    this.$emit('refreshTable')
                    this.active = false
                    this.cicloEscolar = ''
                    this.nivel = ''
                    this.programa = ''
                    this.periodo = ''
                }catch(error){
                    console.error(error)
                }
            }
        },
        async getNivel(){
            try { 
                this.loadingNivel = true
                const response = await catalogos.getNivelesAcademicos(this.institucion)
                this.niveles = response.data
                this.loadingNivel = false
            }catch{
                this.loadingNivel = false
            }
        },
        async getProgramas(){
            if(this.nivel){
                try { 
                    this.loadingPrograma = true
                    const response = await catalogos.getProgramasByNivel(this.institucion, this.nivel)
                    this.programas = response.data
                    this.programaId= (new Date()).getTime()
                    this.loadingPrograma = false
                }catch{
                    this.loadingPrograma = false
                }
            }
        },
        async getPeriodo(){
            if(this.programa){
                try { 
                    this.loadingPeriodo = true
                    const response = await catalogos.getPeriodo(this.programa)
                    this.periodos = response.data
                    this.periodoId= (new Date()).getTime()
                    this.loadingPeriodo = false
                }catch{
                    this.loadingPeriodo = false
                }
            }
        }
    },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        institucion(){
            this.getNivel()
        },
        nivel(){
            this.getProgramas()
        },
        programa(){
            this.getPeriodo()
        }
    }
}
</script>

<style>
    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }
</style>